/* eslint-disable react-native/no-color-literals */
import { StyleSheet } from 'react-native';
import diaryPageStyles from './diary.page';

export default StyleSheet.create({
  ...diaryPageStyles,
});
